import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaEye } from 'react-icons/fa';
import { listMyOrders } from '../actions/orderActions';
import Loader from '../components/ui/Loader';
import Message from '../components/ui/Message';

const OrdersPage = () => {
  const dispatch = useDispatch();
  
  const orderListMy = useSelector(state => state.orderListMy);
  const { loading, error, orders } = orderListMy;
  
  useEffect(() => {
    dispatch(listMyOrders());
  }, [dispatch]);
  
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
      date.getDate()
    ).padStart(2, '0')}`;
  };
  
  const getStatusClass = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'processing':
        return 'bg-blue-100 text-blue-800';
      case 'shipped':
        return 'bg-purple-100 text-purple-800';
      case 'delivered':
        return 'bg-green-100 text-green-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  
  const getStatusText = (status) => {
    switch (status) {
      case 'pending':
        return '待处理';
      case 'processing':
        return '处理中';
      case 'shipped':
        return '已发货';
      case 'delivered':
        return '已送达';
      case 'cancelled':
        return '已取消';
      default:
        return status;
    }
  };
  
  return (
    <div className="orders-page">
      <h1 className="text-3xl font-bold mb-6">我的订单</h1>
      
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant="error">{error}</Message>
      ) : orders && orders.length === 0 ? (
        <div className="bg-white p-6 rounded-lg shadow-md text-center">
          <p className="text-lg mb-4">您还没有订单记录</p>
          <Link to="/products" className="bg-red-700 text-white px-6 py-2 rounded hover:bg-red-800">
            浏览产品
          </Link>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  <th className="p-4 text-left">订单号</th>
                  <th className="p-4 text-left">日期</th>
                  <th className="p-4 text-right">金额</th>
                  <th className="p-4 text-center">状态</th>
                  <th className="p-4 text-center">配送地址</th>
                  <th className="p-4 text-center">操作</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order.id} className="border-t hover:bg-gray-50">
                    <td className="p-4">#{order.id}</td>
                    <td className="p-4">{formatDate(order.created_at)}</td>
                    <td className="p-4 text-right">¥{parseFloat(order.total_amount).toFixed(2)}</td>
                    <td className="p-4 text-center">
                      <span
                        className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${getStatusClass(
                          order.status
                        )}`}
                      >
                        {getStatusText(order.status)}
                      </span>
                    </td>
                    <td className="p-4 text-center">
                      <span className="text-sm text-gray-600 truncate block max-w-xs">
                        {order.shipping_address}
                      </span>
                    </td>
                    <td className="p-4 text-center">
                      <Link
                        to={`/order/${order.id}`}
                        className="inline-flex items-center justify-center bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-1 rounded"
                      >
                        <FaEye className="mr-1" />
                        查看详情
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrdersPage;